import gql from "graphql-tag";

export default gql`
  query TrainingUnitsForCoursePlan($filter: TrainingUnitFilter!) {
    trainingUnits(filter: $filter) {
      id
      date
      active
      canRegister
      isRegistered
      waitingListPosition
      potentialWaitingListPosition
      reservedSeats
      cancelCause
      internalCancelReason
      offTimeReason
      canCancel
      canNotRegisterCause
      courseDate {
        id
        maximumParticipants
        room
        startDate

        course {
          id
          title
          duration
        }

        location {
          id
          name
          hidden
        }
      }
      hasTrialRegistration
    }

    locations {
      id
      name
      hidden
      noShow
    }

    courseCategories {
      id
      title
      hidden
      noShow
    }
  }
`;
